<script>

import TrainingSeriesForm from "@/components/trainingSeries/form/TrainingSeriesForm.vue";
import {getPreferredLocale} from "@/utils/locale.js";

export default {
    components: {TrainingSeriesForm},
    data() {
        return {
            training: {
                name: '',
                price: '',
                description: '',
                is_active: 1,
                is_series: 1,
                language: getPreferredLocale()
            }
        }
    }
}

</script>
<template>
    <div class="trainings-create">
        <TrainingSeriesForm :training="training"/>
    </div>
</template>
